import { formatTime } from '../../lib/format';

export function Timestamp({ epochMs, className = '' }: { epochMs: number; className?: string }) {
  return (
    <span className={`text-[11px] text-[#667781] ${className}`.trim()}>
      {formatTime(epochMs)}
    </span>
  );
}
